import * as yup from 'yup'
import type { CRM } from '../modules/crmSelector/action'

export const yupObjectShaper = (crm: CRM) => {
  const errors: Record<string, yup.AnySchema> = {}
  crm.credential_fields.forEach(c => {
    if (c.type === 'string') {
      let stringSchema = yup
        .string()
        .typeError(`${c.label} should be of type string.`)
      c.required
        ? (stringSchema = stringSchema.required(`${c.label} is required.`))
        : ''
      c.min_length && c.min_length > 0
        ? (stringSchema = stringSchema.min(
            c.min_length,
            `${c.label} should have minimum ${c.min_length} character(s).`
          ))
        : ''
      c.max_length && c.max_length > 0
        ? (stringSchema = stringSchema.max(
            c.max_length,
            `${c.label} should have maximum ${c.max_length} character(s).`
          ))
        : ''
      errors[c.key] = stringSchema
    } else if (c.type === 'integer') {
      let numberSchema = yup
        .number()
        .typeError(`${c.label} should be of type number.`)
      c.required
        ? (numberSchema = numberSchema.required(`${c.label} is required.`))
        : ''
      c.min_value && c.min_value > 0
        ? (numberSchema = numberSchema.min(
            c.min_value,
            `${c.label} should have minimum value of ${c.min_value}.`
          ))
        : ''
      c.max_value && c.max_value > 0
        ? (numberSchema = numberSchema.max(
            c.max_value,
            `${c.label} should have maximum value of ${c.max_value}.`
          ))
        : ''
      errors[c.key] = numberSchema
    }
  })
  return errors
}
